import { Router } from './router.js';

document.addEventListener('DOMContentLoaded', () => {
    // Inicializamos el router apuntando al contenedor principal de tu HTML
    const router = new Router('app-container');
});